module.exports = ".mb16 {\n    margin-bottom: 16px;\n}\n.mb8 {\n    margin-bottom: 8px;\n}\n.text-uppercase {\n    text-transform: uppercase;\n}\n.terceiro {\n    position: relative;\n    top: 16px;\n}\n.input-hint {\n    font-size: 12px;\n}\n\n.containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/bens/frotas/frota-form/frota-form.component.css
 ** module id = 390
 ** module chunks = 0
 **/